module.exports = __webpack_public_path__ + "static/img/noComment.8d65dd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/noComment.png
// module id = 34
// module chunks = 2 3 4 5 6 9